module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4BGoc"))).then(() => parcelRequire('hEqeo'));